export const SET_PRODUCTION_SCHEDULES = "SET_PRODUCTION_SCHEDULES"

export const setProductionSchedules = payload => dispatch => {
   dispatch({ type: SET_PRODUCTION_SCHEDULES, payload })
}

export default SET_PRODUCTION_SCHEDULES
